import { render } from "./categoryColumn.vue?vue&type=template&id=85cdbe46"
import script from "./categoryColumn.vue?vue&type=script&lang=js"
export * from "./categoryColumn.vue?vue&type=script&lang=js"

import "./categoryColumn.vue?vue&type=style&index=0&id=85cdbe46&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__